import {Store, _, waitFor} from 'utils';
import { start } from '../../index';
import ActiveStore from './ActiveFilters';

const MIN = 0;
const MAX = 10;

class QualificationStore extends Store {

	getInitialState() {
		return {
			qualifications: [],
			languages: [],
			languageLevel:[
				{name:'basic',key:1},
				{name:'advanced',key:2},
				{name:'professional',key:3},
				{name:'native',key:4},
			],
			languageFilter: [],
			jobTypes: [],
			driverLicensceTypes: [],
			managersExpiriences: false,
			experience: {
				min: MIN,
				max: MAX
			},
			visible: false,
			filters: [],
		}
	}

	onRemoveFilter(state, data) {
		const { filter } = data;

		if(filter.src == 'experience') {
			if(filter.min) {
				state.experience.min = MIN;
			}

			if(filter.max) {
				state.experience.max = MAX;
			}
		}

		if(filter.src == 'qualification') {
			state.qualifications = state.qualifications.map(function(item) {
				if(item.key == filter.key) {
					var item = Object.assign({}, item);
					item.selected = false;
				}
				return item;
			});
		}

		if(filter.src == 'language') {
			state.languages = state.languages.map(function(item) {
				if(item.key == filter.sid) {
					var item = Object.assign({}, item);
					item.selected = false;
				}
				return item;
			});
		}

		if(filter.src == 'languageFilter') {
			state.languageFilter = state.languageFilter.map(function(item) {
				if(item.src == filter.key) {
					var item = Object.assign({}, item);
					item.selected = false;
					$('#' + item.src).removeClass('selected');

				}
				return item;
			});
		}

		if(filter.src == 'job_types') {
			state.jobTypes = state.jobTypes.map(function(item) {
				if(item.key == filter.key) {
					var item = Object.assign({}, item);
					item.selected = false;
				}
				return item;
			});
		}

		if(filter.src == 'driving_category') {
			state.driverLicensceTypes = state.driverLicensceTypes.map(function(item) {
				if(item.key == filter.key) {
					var item = Object.assign({}, item);
					item.selected = false;
				}
				return item;
			});
		}

		if(filter.src == 'managerial_experience') {
			state.managersExpiriences = false;
		}
	}

	get experienceRange() {
		const { experience: { min, max } } = this.getState();
		const experience = {};

		if(!this.isMaxExperience(max)) {
			experience.max = max;
		}

		if(!this.isMinExperience(min)) {
			experience.min = min;
		}

		return experience;
	}
	onApplyFilters(state, data){
		waitFor([ActiveStore]);
		state.filters = ActiveStore.getState().filters;
	}
	get filterState() {
		const {
			qualifications, 
			experience,
			languages,
			jobTypes,
			driverLicensceTypes,
			managersExpiriences,
			languageLevel,
			languageFilter
		} = this.getState();

		return ({
			driverLicensceTypes: driverLicensceTypes.filter(item => item.selected),
			qualifications: qualifications.filter(item => item.selected),
			experience: this.experienceRange,
			jobTypes: jobTypes.filter(item => item.selected),
			managersExpiriences,
			languages: languages.filter(item => item.selected),
			languageLevel: languageLevel.filter(item => item.selected),
			languageFilter:languageFilter.filter(item => item.selected)
		});
	}

	onAdvancedFiltersChanged(state, data) {
		if (data.jobTypes) {
			state.jobTypes = data.jobTypes.map((d, idx) => ({
				key: d.src,
				name: d.value,
				selected: false,
			}))
		}

		if (data.licenses) {
			state.driverLicensceTypes = data.licenses.map((d, idx) => ({
				key: d.src,
				name: d.value,
				selected: false,
			}));
		}
	}

	onQualificationsChanged(state, data) {
		state.qualifications = data.qualifications.map((item) => ({
			selected: state.filters.filter((item2) => ((item2.key == item.key) && (item2.src == 'qualification'))).length,
			key: item.key,
			name: item.value,
		}));
	}

	onLanguagesChanged(state, data) {
		state.languages = data.languages.map((item) => ({
			key: item.key,
			name: item.name
		}));
	}

	onShowFilters(state) {
		state.visible = true;
	}

	onHideFilters(state) {
		state.visible = false;
	}

	addItem(arr, item) {
		const { length } = arr;
		const id = length + 1;
		const found = arr.some(el => el.src === item.src);
		if (!found){
			arr.push(item);
		}else{
			var index = arr.findIndex(item2 => item2.src === item.src);
			arr.splice(index, 1, item)
		}
		return arr;
	}

	onToggleFilter(state, { filterName, data, key }) {
		if(typeof(state[filterName]) === "boolean") {
			state[filterName] = !data.selected;
		} else if (Array.isArray(state[filterName]) && filterName != 'languageLevel') {
			state[filterName] = state[filterName].map(item => ({
				...item,
				selected: (item.key === data.key) ? !item.selected : item.selected
			}));
		} else if(filterName == 'languageLevel') {

			let newField = state.languageFilter;

			state.languageLevel.map(item => {

				item.src = key + '-' + item.key;
				item.description = key + ' - ' + _(item.name);
				item.active = key + ' - ' + _(item.name);
				item.parent = key;

				if (item.selected && (item.src == (key + '-' + data.key)))
				{
					$('#' + key + '-' + item.key).removeClass('selected');
					item.selected = false;
					newField = this.addItem(newField, item);
				}
				else
				{
					if (item.key == data.key)
					{
						$('#' + key + '-' + item.key).addClass('selected');
						item.selected = true;
						newField = this.addItem(newField, item);
					}
					else
					{
						$('#' + key + '-' + item.key).removeClass('selected');
						item.selected = false;
						newField = this.addItem(newField, item);
					}
				}

			});

			state.languageFilter = newField;
			state.languageFilter = state.languageFilter.map(item => ({
				...item,
			}));
		}
	}

	isMinExperience(val) {
		return MIN == val;
	}

	isMaxExperience(val) {
		return MAX == val;
	}

	onExperienceRangeChanged(state, data) {
		state.experience = {
			min: data.min,
			max: data.max
		}
	}

	onResetExperienceRange(state) {
		state.experience = {
			min: MIN,
			max: MAX
		}
	}

	onResetQualifications(state) {
		state.qualifications = state.qualifications.map(function(item) {
			item.selected = false;
			return item;
		});
	}

	onResetLanguages(state) {
		state.languages = state.languages.map(function(item) {
			item.selected = false;
			return item;
		});
	}

	onResetLanguageLevel(state) {
		state.languageLevel = state.languageLevel.map(function(item) {
			item.selected = false;
			return item;
		});
	}

	onResetJobtypes(state) {
		state.jobTypes = state.jobTypes.map(item => ({ ...item, selected: false }));
	}

	onResetDriverLicenseTypes(state) {
		state.driverLicensceTypes = state.driverLicensceTypes.map(item => ({ ...item, selected: false }));
	}

	onResetManagersExpirience(state) {
		state.managersExpiriences = false;
	}
}

const store = new QualificationStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/QualificationStore.js